module.exports = __webpack_public_path__ + "img/followoninsta.45757006.jpg";